import { CodeRow, Collapsible, StepBlock, VerifyStepShell } from './verifyShared';

const PROVIDERS = ['GoDaddy', 'Cloudflare', 'Namecheap', 'Squarespace',
                   'Hover', 'Google Domains', '123-Reg', 'Other…'];

export default function VerifyDnsStep(props) {
  const { domain, instructions } = props;
  const dns = (instructions && instructions.dns) || {};
  const value = dns.value || '';

  return (
    <VerifyStepShell title={`Verify ${domain} with DNS`} autoNote="Auto-checking every 10 seconds…" {...props}>
      {/* STEP 1 — log in to DNS provider */}
      <StepBlock n={1} title="Log in to your DNS provider">
        <p className="font-body" style={{ color: 'var(--ts)', fontSize: '0.84rem' }}>
          This is where you bought or manage your domain. Common providers:
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0.5rem',
                      marginTop: '0.75rem' }}>
          {PROVIDERS.map((p) => (
            <span key={p} className="font-body" style={{
              textAlign: 'center', padding: '0.45rem 0.5rem', borderRadius: 6,
              border: '1px solid var(--b1)', color: 'var(--tm)', fontSize: '0.8rem',
            }}>
              {p}
            </span>
          ))}
        </div>
        <p className="font-body" style={{ color: 'var(--ts)', fontSize: '0.8rem', marginTop: '0.7rem' }}>
          Don&apos;t know who manages your DNS? →{' '}
          <a href="https://lookup.icann.org/en/lookup" target="_blank" rel="noreferrer"
             style={{ color: 'var(--a)' }}>Check using our tool</a>
        </p>
      </StepBlock>

      {/* STEP 2 — add the TXT record */}
      <StepBlock n={2} title="Add this TXT record">
        <div style={{ border: '1px solid var(--b1)', borderRadius: 8, overflow: 'hidden',
                      background: 'var(--bg)' }}>
          <CodeRow label="Type" value="TXT" copyable={false} />
          <CodeRow label="Name/Host" value={dns.name || '@'} />
          <CodeRow label="Value" value={value} />
          <CodeRow label="TTL" value={String(dns.ttl || 3600)} copyable={false} />
        </div>

        <Collapsible title="💡 Tips — field names vary by provider">
          <ul style={{ paddingLeft: '1.1rem', margin: 0 }}>
            <li>“Host” might be called “Name” or “Record name”.</li>
            <li>“@” means your root domain — some providers want the full domain like {domain}.</li>
            <li>If you can&apos;t find the TXT type, look under “Advanced DNS”.</li>
          </ul>
        </Collapsible>

        <Collapsible title="Show me how — GoDaddy">
          <ol style={{ paddingLeft: '1.1rem', margin: 0 }}>
            <li>Log in to godaddy.com</li>
            <li>Click “My Products” in the top right</li>
            <li>Find {domain} in your domains list and click “DNS”</li>
            <li>Scroll to “DNS Records”</li>
            <li>Click “Add” → select “TXT”</li>
            <li>Paste the values shown above</li>
            <li>Click “Save”</li>
          </ol>
        </Collapsible>

        <Collapsible title="Show me how — Cloudflare">
          <ol style={{ paddingLeft: '1.1rem', margin: 0 }}>
            <li>Log in to dash.cloudflare.com</li>
            <li>Select {domain} from the list</li>
            <li>Click “DNS” in the left sidebar</li>
            <li>Click “Add record”</li>
            <li>Type: TXT, Name: @ (or the exact domain), Content: paste the value</li>
            <li>Click “Save”</li>
          </ol>
        </Collapsible>

        <Collapsible title="Squarespace, Namecheap & others">
          <p style={{ margin: 0 }}>
            Coming soon — for now follow your provider&apos;s official guide for adding a TXT record,
            using the Type / Name / Value above.
          </p>
        </Collapsible>
      </StepBlock>

      {/* STEP 3 — save and wait */}
      <StepBlock n={3} title="Save and wait">
        <ul style={{ paddingLeft: '1.1rem', margin: 0, color: 'var(--tm)', fontSize: '0.84rem',
                     lineHeight: 1.7 }}>
          <li>Cloudflare: near-instant</li>
          <li>Most others: 5–30 minutes</li>
          <li>Worst case: up to 24 hours</li>
        </ul>
        <p className="font-body" style={{ color: 'var(--ts)', fontSize: '0.82rem', marginTop: '0.7rem' }}>
          You can close this page. We&apos;ll keep checking automatically.
        </p>
      </StepBlock>
    </VerifyStepShell>
  );
}
